import React, { useEffect, useState, useMemo } from "react";
import { Switch, Route } from "react-router-dom";
import ErrorPage from "../../src/components/JobApplication/Shared/ErrorPage"

// react-bootstrap components
import {
    Badge,
    Button,
    ButtonGroup,
    Card,
    Form,
    InputGroup,
    Navbar,
    Nav,
    Pagination,
    Container,
    Row,
    Col,
} from "react-bootstrap";
import { useSelector, useDispatch } from 'react-redux'

// core components
import Sidebar from "components/Sidebar/Sidebar.js";
import AdminNavbar from "components/Navbars/AdminNavbar.js";
import Footer from "components/Footers/Footer.js";
import { authProvider } from "authProvider.js";
import { AzureAD, AuthenticationState } from "react-aad-msal";
import JobApplicationWizard from "views/JobApplication/JobApplicationWizard";
import ManageInductionViewer from "views/InductionViewer/ManageInductionViewer";


// dinamically create dashboard routes
import routes from "routes.js";

import Home from "views/Home.js";

function Admin() {
    const dispatch = useDispatch()
    const user = useSelector((state) => state.user);
    const isFavourites = useSelector((state) => state.isFavourites);
    const [adAccount, setADAccount] = useState(null);


    const fetchUser = async (employeeId) => {
        try {
            //if (employeeId > 0) {
            const response = await fetch(`/user/getuser?employeeId=${employeeId}&objectId=${adAccount?.account.idToken.oid}&username=${adAccount?.account.name}`);
            const data = await response.json();
            dispatch({ type: 'set', user: data });
            //}
        } catch (err) {
        }
    }

    const fetchEmployeeId = async (username) => {
        try {
            if (username !== null && username !== undefined) {
                const response = await fetch(`/employee/getemployeeidbyusername?username=${username}`);
                const data = await response.json();
                if (data !== null)
                    fetchUser(data);
            }
        } catch (err) {
        }
    }

    //useEffect(() => {
    //    if (adAccount !== null) {
    //        fetchEmployeeId(adAccount?.account.name);
    //    }
    //}, [adAccount]);

    const sRoutes = useMemo(() => {
        let sideRoutes = [...routes];
        let timeMachine = { ...sideRoutes[0] };
        let populi = { ...sideRoutes[1] }
        let timeMachineView = [];

        //if (user?.permissions) {
        //    const timeMachinePermissions = user?.permissions?.filter((item) => item.name.includes("TimeMachine") && item.name.includes("View"));

        //    timeMachine?.views?.map((view) => {
        //        const data = timeMachinePermissions?.filter((item) => {
        //            return view.permission === item.name;
        //        })
        //        if (data?.length)
        //            timeMachineView.push(view);
        //    });
        //}

        sideRoutes[0] = { ...timeMachine, views: timeMachineView };

        return sideRoutes;
    }, [user]);

    const sideRoutes = useMemo(() => {
        let sideRoutes = [...sRoutes];
        let timeMachine = { ...sideRoutes[0] };
        let populi = { ...sideRoutes[1] }
        let timeMachineView = [];

        //if (isFavourites) {
        //    if (user?.favourites) {
        //        // TimeMachine Route
        //        timeMachine?.views?.map((view) => {
        //            const data = user?.favourites?.filter((item) => {
        //                return view.path === item.favourite;
        //            })
        //            if (data?.length)
        //                timeMachineView.push(view);
        //        });

        //        // Populi Route
        //    }

        //    sideRoutes[0] = { ...timeMachine, views: timeMachineView };
        //}

        return sideRoutes;
    }, [sRoutes, user, isFavourites]);

    const getRoutes = (routes) => {
        return routes.map((prop, key) => {
            if (prop.collapse) {
                return getRoutes(prop.views);
            }

            return (
                <Route
                    path={prop.path}
                    key={key}
                    component={prop.component}
                />
            );
        });
    };

    return (
        <>
            <div className="wrapper">
                <Sidebar
                    routes={sideRoutes}
                />
                <div className="main-panel">
                    <AdminNavbar />
                    <div className="content">
                        <Switch>
                            <Route exact path="/" component={Home} />
                            <Route path="/jobapplicationwizard/apply/:id" render={(props) => <JobApplicationWizard {...props} />} />
                            <Route
                                path="/inductionViewer/:id/:inductionId/:pin/"
                                render={(props) => <ManageInductionViewer {...props} />}
                            />
                            {/* <Route path="/hrInduction" render={(props) => <HRInductionWizard {...props} />} />
                            <Route path="/hsInduction" render={(props) => <HSInductionWizard {...props} />} />
                            <Route path="/onboarding" render={(props) => <OnboardingWizard {...props} />} /> */}



                            {getRoutes(routes)}

                            <Route render={() => <ErrorPage />} />
                        </Switch>
                    </div>
                    <Footer />
                    <div
                        className="close-layer"
                        onClick={() =>
                            document.documentElement.classList.toggle("nav-open")
                        }
                    />
                </div>
            </div>
        </>
    );
}

export default Admin;
